export default __webpack_public_path__ + "static/media/Edit_icon1.0cfeee5a.svg";